import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import wrapInContainerStyles from "@insite/client-framework/Common/wrapInContainerStyles";
import { BadgeModel } from "@insite/client-framework/Types/ApiModels";
// import Badge from "@insite/mobius/Badge"; // Custom Code
import { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { useState } from "react";
import { css } from "styled-components";

/* Custom Code */
import TagWrapper, { TagWrapperProps } from "@store/Library/Components/Toolkit/TagWrapper";
import Badge from "@store/MobiusOverrides/Badge/Badge";
import { badgeProps } from "@store/Themes/common/props/badge";
/* Custom Code */

interface Props {
    badgeList: BadgeModel[];
    maxBadges: number;
    extendedStyles?: ProductTextBadgesStyles;
}

export interface ProductTextBadgesStyles {
    container?: InjectableCss;
    badge?: InjectableCss;
    badgeText?: TypographyPresentationProps;
    // Custom Code
    tagWrapper?: TagWrapperProps;
}

export const productTextBadgesStyles: ProductTextBadgesStyles = {
    tagWrapper: badgeProps.tagWrapper,
    badgeText: badgeProps.badgeText,
};

const ProductTextBadges = ({ badgeList, maxBadges, extendedStyles }: Props) => {
    const [styles] = useState(() => mergeToNew(productTextBadgesStyles, extendedStyles));

    return (
        <TagWrapper {...styles.tagWrapper} data-test-selector="textBadges" /* Custom Code */>
            {badgeList.slice(0, maxBadges).map(badge => (
                /* Removed - StyledWrapper */
                <Badge
                    key={badge.id} // Custom Code
                    type={badge.badgeType}
                    value={badge.displayText}
                    badgeTextColor={badge.textColorHexCode}
                    badgeBackgroundColor={badge.badgeColorHexCode}
                    badgeTextRounding={badge.badgeStyle === "Round"} // Custom Code
                    textBadgeCss={styles.badgeText}
                    {...styles.badge}
                />
            ))}
        </TagWrapper>
    );
};

export default ProductTextBadges;
